import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { designRoles } from '../common/designRoles';

/**
 * The car and the campaign: the plate in its badge, as the feed's other
 * cards show it (8 characters: a new-energy plate, in green), then the
 * campaign's title.
 */
export const PlateTitle = memo(
  ({ plate, campaign }: { plate: string; campaign: string }) => {
    const { rpx } = useResponsiveContext();
    const plateColor = plate.length === 8 ? '#40c779' : '#1f80ff';
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: rpx(8),
        }}
      >
        <View
          style={{
            paddingHorizontal: rpx(8),
            paddingVertical: rpx(2),
            borderRadius: rpx(4),
            borderWidth: 1,
            borderColor: plateColor,
          }}
        >
          <Typography.Text
            size={rpx(15)}
            color={plateColor}
            bold
            letterSpacing={1}
          >
            {plate}
          </Typography.Text>
        </View>
        <Typography.Text
          accessibilityRole="header"
          size={rpx(15)}
          lineHeight={rpx(22)}
          color={designRoles.textPrimary}
          medium
          style={{ flexShrink: 1 }}
        >
          {campaign}
        </Typography.Text>
      </View>
    );
  },
);
